export function joinStringArray(
    items: Array<string | null | undefined>,
    seperator = ', ',
    lastSeperator = seperator,
): string {
    const filteredItems = items.filter(str => str !== undefined && str !== null).filter(str => str !== '');

    if (filteredItems.length <= 1) {
        return filteredItems.pop() ?? '';
    }
    return `${filteredItems.slice(0, -1).join(seperator)}${lastSeperator}${filteredItems.slice(-1)}`;
}
